export default __webpack_public_path__ + "9dfd1f5443d4736e110ece4f8b14869a.png";